
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.618.87c.2.2.252.503.131.758l-6 12.666a.667.667 0 01-1.25-.123L6.265 9.225 1.318 7.99a.667.667 0 01-.123-1.25l12.666-6a.667.667 0 01.757.132zM3.448 7.148l3.527.882c.239.06.425.246.485.485l.882 3.526 4.403-9.296L3.45 7.147z","fill":"#F07D19"}})])
          )
        }
      }
    